module.exports = __webpack_public_path__ + "static/media/17.c9e7371a.jpg";